import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import DashboardListContainer from '../../../sharable/components/DashboardListContainer';
import ArticlesListItem from '../ArticlesListItem';
import { selectArticlesListIds } from '../../reducers/articlesSelectors';

const ArticlesList = (): ReactElement => {
  const articlesIds = useSelector(selectArticlesListIds);

  return (
    <DashboardListContainer>
      {articlesIds.map((id, index) => (
        <ArticlesListItem articleId={id} key={`${id}-${index}`} />
      ))}
    </DashboardListContainer>
  );
};

export default ArticlesList;
